const actions = {
  SET_LICENSE_LIST: 'SET_LICENSE_LIST',
  UPDATE_LICENSE: 'UPDATE_LICENSE',

  updateLicenseList: data => {
    return { type: actions.UPDATE_LICENSE, data };
  },
};
export default actions;
